import React, { useContext, useEffect, useRef, useState } from 'react'
import { RechargeList, TransactionsList, getListeCarteprépayée } from '../requests/transfer'
import UserContext from 'contexts/UserContext'
import HistoryTable from './historyContainer/historyTable'

import HistoryTableRecharge from './historyContainer/historyTableRecharge'
import { historyinvoices } from 'requests/paiement'
import { Spinner } from 'utils/loading'
import { useLocation } from 'react-router-dom'
import ArrowDown from '../assets/iconTsx/DropDown'
// import Pagination from 'components/table/Pagination'
import Table from 'components/table/Table'
import Pagination from 'components/table/Pagination'

type StatusItem = {
  codes: number[];
  value: string;
}

type ListeStatusType = {
  label: string;
  status: StatusItem[]
}

const History = () => {
  const [transactionData, setTransactionData] = useState<any>([])
  const [rechargeData, setrechargeData] = useState<any>([])

  const [legnth, setLength] = useState<any>(0)

  const [isBankAccount, setIsBankAccount] = useState([])

  const { user } = useContext(UserContext)
  const [loading, setLoading] = useState(true)
  const [activeText, setActiveText] = useState(1)

  const [indexStatus, setIndexStatus]=useState(1)

  const [status, setStatus]=useState('')
  const [page, setPage]=useState(1)
  const [totalPages,setTotalPages]=useState<number>(1)
  const [limit, setLimit]= useState(10)

  const [showOptions, setShowOptions] = useState(false)
  const [selectedOption, setSelectedOption] = useState('')
  const [placeholder, setPlaceholder] = useState("Transfert d'argent avec retrait en cash")

  const location = useLocation()

  const divRef = useRef<HTMLDivElement>(null)
  const dropDownRef = useRef<HTMLDivElement>(null)
  const id = user?.user?._id
  const token = user?.token?.accessToken

  const ListeStatus: ListeStatusType[] =[
    {label:'En cours',
       status:[
        { codes: [1, 2, 3, 4], value: 'in progress' },
        { codes: [6], value: 'created' },
      ]},

    { label:'Terminé',
      status:[
        { codes: [1, 2, 5, 6], value: 'complete' },
        { codes: [3,4], value: 'Complete' },
      ]
    },
    { label:'Annulé',
      status:[
        { codes: [1, 2, 3, 4,5,6], value: 'canceled' }
      ]
    },
    
  ]
  
  const handleClickOutside = (event: any) => {
    if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
      // toggleSetting()
      setShowOptions(false)
    }
  }
  const listHistory = [
    {
      id: 1,
      name: "Transfert d'argent avec retrait en cash",
    },
    {
      id: 2,
      name: "Transfert d’argent de compte à compte ",
    },
    {
      id: 3,
      name: "Transfert d'argent vers Wallet",
    },

    {
      id: 4,
      name: 'Recharge mobile',
    },
    {
      id: 5,
      name: 'Recharge de carte prépayée',
    },

    
    {
      id: 6,
      name: 'Paiement de factures locales',
    },
  ]
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const activeTextParam = params.get('activeText')
    const parsed = activeTextParam ? parseInt(activeTextParam) : 1   
    setActiveText(parsed)
    setPlaceholder(listHistory[parsed - 1].name)
  }, [location])

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleIconClick = () => {
    setShowOptions(!showOptions)
  }

  const handleOptionSelect = (option: any) => {
    setSelectedOption(option)
    setShowOptions(false)
  }

  useEffect(() => {
    if (!id || !token) return
    async function fetchData() {
      HandleSlectedListe(ListeStatus[indexStatus], 1, activeText)
      setLoading(true)
      try {
        let response
        setTotalPages(0)
        switch (activeText) {
          case 1:
            
            response = await TransactionsList(id, token, 'cash_pickup', status, page,limit)
            if (response?.success === true) {
          
              setPage(response.pagination.page)
              setLimit(response.pagination.limit)
              setTotalPages(response.pagination.total)
              setTransactionData(response.transfers)
              setLength(response.transfers.length)
              setLoading(false)
            }

            break
          case 2:
            response = await TransactionsList(id, token, 'bank_account', status, page,limit)

            if (response?.success === true) {
              setPage(response.pagination.page)
              setLimit(response.pagination.limit)
              setTotalPages(response.pagination.totalPages)
              setTransactionData(response.transfers)
              setLength(response.transfers.length)
              setLoading(false)
            }

            break
          case 4:
            response = await RechargeList(id, token, status, page, limit)
            if (response?.success === true) {
              setPage(response.pagination.page)
              setLimit(response.pagination.limit)
              setTotalPages(response.pagination.totalPages)
              setrechargeData(response?.recharges)
              setLoading(false)
            }

            break
          case 5:
            if (id || location.state?.type === 'carte-prepayee') response = await getListeCarteprépayée(id, token, status, page, limit)
            if (response?.success === true) {
              setPage(response.pagination.page)
              setLimit(response.pagination.limit)
              setTotalPages(response.pagination.totalPages)
              setrechargeData(response?.prepaidList)
              setLoading(false)
            }

            break
          case 3:
            response = await TransactionsList(id, token, 'digital_wallet' , status, page,limit)
            if (response?.success === true) {
              setPage(response.pagination.page)
              setLimit(response.pagination.limit)
              setTotalPages(response.pagination.totalPages)
              setTransactionData(response.transfers)
              setLoading(false)
            }
            break
          case 6:
            response = await historyinvoices(id, token, status, page, limit)
            if (response?.success === true) {
              setPage(response.pagination.page)
              setLimit(response.pagination.limit)
              setTotalPages(response.pagination.totalPages)
              setTransactionData(response.invoices)
              setLoading(false)
            }
        }
      } catch (error) {
        setLoading(false)
        console.log(error)
      }
    }
    fetchData()
  }, [activeText, location, id, token, status, page])

  const handleTextClick = (textNumber: any) => {
    if (textNumber !== activeText) {
      setLoading(true)
      setActiveText(textNumber)
    }
  }

  const HandleSlectedListe=(item:any, index:number, activeText:number)=>{
    const StatusSelected = item.status.find(
                    (s:StatusItem) => s.codes.includes(activeText)
                  )?.value
                setStatus(StatusSelected)
                  // setPage(1)

  }


  return (
    <div className="  flex flex-col gap-10 h-screen ">
      <h2
        ref={divRef}
        className="h1 mt-4"
      >
        Historique
      </h2>

      <div className="relative mx-auto" ref={dropDownRef}>
        <div onClick={() => { handleIconClick()}}
          className={` ${showOptions ? 'text-[#5754E5]' : 'text-[#35258B]'}  text-[14px] font-medium font-roboto flex justify-between w-[500px] lg:w-full  items-center px-3  border border-[#AEB6FB] hover:cursor-pointer rounded-[16px] h-[40px] `}
        >            
            {listHistory[activeText - 1].name} 
        
          <ArrowDown styleCssImage={` ${showOptions ? 'fill-[#5754E5] rotate-180' : 'fill-[#AEB6FB]'} `} />
        </div>

        {showOptions && (
          <div className="absolute mt-1 hover:cursor-pointer  bg-white border border-gray-200 rounded-md w-[500px] lg:w-full z-10 shadow-lg">
            {listHistory.map((item: any, index: number) => (
              <div
                key={index}
                onClick={() => {
                  setShowOptions(false)
                  handleOptionSelect(item.name)
                  handleTextClick(item.id)
                }}
                className={` ${item.id === activeText && 'bg-[#F1F1FF] text-[#5754E5]'} text-[#35258B] hover:text-[#4D36CC] text-[16px] font-medium py-2 pl-4`}
              >
                {item.name}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className=' flex flex-col items-center gap-6 shadow-[0px_5px_50px_-6px_rgba(0,0,0,0.1)] rounded-[8px] pb-4 px-1'>
         <div className='bg-[#F1F1FF] w-[500px] sm:w-full flex rounded-[10px] h-[52px] justify-between items-center mt-4 px-6 lg:px-3 font-bold font-roboto text-[14px] '>
          {ListeStatus.map((item: any, index:number)=>(
          <div key={index} className={`${indexStatus===index? 'text-white bg-[#5754E5] py-2 rounded-[12px]' : 'text-[#5754E5]' } cursor-pointer px-4 `}
          onClick={()=> {
            const StatusSelected = item.status.find(
                    (s:StatusItem) => s.codes.includes(activeText)
                  )?.value
                setStatus(StatusSelected)
                setIndexStatus(index)
                setPage(1)
          }
          }
          >
            {activeText===1 && item.label==='En cours' ? 'À retirer' : item.label}

          </div>
          )) }
          
        </div>


        <div>
        {loading ? (
          <div className="flex justify-center w-full">
            <Spinner name="line-scale-pulse-out-rapid" color="#1466ff" fadeIn="none" />
          </div>
        ) : (
          <div className="overflow-y-auto max-h-[500px] lg:max-h-[300px] h-screen scrollbar-webkit w-full ">
            {activeText === 1 && (
              <div>
                {isBankAccount && legnth !== 0 ? (
                  <HistoryTable
                    typeTransfert="cash_pickup"
                    transactionData={transactionData.filter((item: any) => item?.distributionChannel === 'cash_pickup')}
                  />
                ) : (
                    <div className="border-2 border-dashed border-[#5754E5] w-[80%] mx-auto  sm:text-[14px]  text-[20px] text-center text-[#6B6B6B] rounded-2xl py-3 px-2">
                    Aucun transfert avec retrait en cash n&apos;a été effectué jusqu&apos;à présent. Commencez
                    maintenant !
                  </div>
                )}
              </div>
            )}
            {activeText === 2 && (
              <div>
                {transactionData.length !== 0 ? (
                  <HistoryTable
                    typeTransfert="bank_account"
                    transactionData={transactionData.filter(
                      (item: any) => item?.distributionChannel === 'bank_account',
                    )}
                  />
                ) : (
                    <div className="border-2 border-dashed border-[#5754E5] w-[80%] mx-auto   sm:text-[14px]  text-[20px] text-center text-[#6B6B6B] rounded-2xl py-3 px-2">
                    Aucun transfert vers un compte bancaire n&apos;a été effectué jusqu&apos;à présent. Commencez
                    maintenant !
                  </div>
                )}
              </div>
            )}

            {activeText === 4 && (
              <div>
                {rechargeData.length !== 0 ? (
                  <HistoryTableRecharge rechargeData={rechargeData} data="Recharge Mobile" />
                ) : (
                    <div className="border-2 border-dashed border-[#5754E5] w-[80%] mx-auto  sm:text-[14px]  text-[20px] text-center text-[#6B6B6B] rounded-2xl py-3 px-2">
                    Aucune recharge mobile n&apos;a été effectuée jusqu&apos;à présent. Commencez maintenant !
                  </div>
                )}
              </div>
            )}

            {activeText === 5 && (
              <div>
                {rechargeData.length !== 0 ? (
                  <HistoryTableRecharge rechargeData={rechargeData} data="cartePrepayee" />
                ) : (
                    <div className="border-2 border-dashed border-[#5754E5] w-[80%] mx-auto  sm:text-[14px]  text-[20px] text-center text-[#6B6B6B] rounded-2xl py-3 px-2">
                    Aucune recharge n&apos;a été effectuée jusqu&apos;à présent. Commencez maintenant !
                  </div>
                )}
              </div>
            )}

            {activeText === 3 && (
              <div>
                {transactionData.length !== 0 ? (
                  <HistoryTable
                    typeTransfert="digital_wallet"
                    transactionData={transactionData.filter(
                      (item: any) => item?.distributionChannel === 'digital_wallet',
                    )}
                  />
                ) : (
                    <div className="border-2 border-dashed border-[#5754E5] w-[80%] mx-auto   sm:text-[14px]  text-[20px] text-center text-[#6B6B6B] rounded-2xl py-3 px-2">
                    Aucun transfert vers un wallet n&apos;a été effectué jusqu&apos;à présent. Commencez maintenant !
                  </div>
                )}
              </div>
            )}


              {activeText === 6 && (
              <div>
                {transactionData.length !== 0 ? (
                  <HistoryTable typeTransfert="Facture" transactionData={transactionData} />
                ) : (
                  <div className="border-2 border-dashed border-[#5754E5] sm:w-[330px] ml-5 mr-10 mt-[55px] sm:mt-[25px] w-auto sm:max-w-max sm:text-[14px] 2sm:text-[12px] 2sm:w-[300px] 2sm:mb-5 text-[20px] text-center text-[#6B6B6B] rounded-2xl py-3 px-2">
                    Aucune facture n&apos;a été payée jusqu&apos;à présent. Commencez maintenant !
                  </div>
                )}
              </div>
            )}

                </div>
              )}
      </div>
    
    { totalPages!==0 &&  <Pagination
            currentPage={page}
            pageSize={limit}
            totalCount={totalPages}
            onPageChange={(page)=>setPage(page)}
          />}
          
          {/* <Pagination
            currentPage={1}
            pageSize={20}
            totalCount={100}
            onPageChange={(page)=>setPage(page)}
          /> */}
        
      </div>
      
    </div>
  )
}

export default History
